import {AfterViewInit, Component, inject, ViewChild} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TabViewModule } from 'primeng/tabview';
import { RevocacionRespuestaComponent } from './revocacion-respuesta.component';
import { ActivatedRoute } from '@angular/router';
import {CustomTitleDirective} from "../../../../shared/clases/custom-title.directive";

@Component({
	selector: 'app-revocacion-seguimiento',
	standalone: true,
	imports: [TabViewModule, TranslateModule, RevocacionRespuestaComponent],
	template: `
  <section class="flex justify-content-center mt-4">
      <div class="card-table col-12">
          <div>
                <h1 class="font-roboto-condensed font-23 title-blue text-uppercase font-normal mb-0">{{'msg.actividadesAsociadasRevocacion' | translate}}</h1>
          </div>
          <div>
              <p class="color-general-blue">{{title}}</p>
          </div>
          <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
              <p-tabPanel>
                  <ng-template pTemplate="header">
                      <div class="flex gap-1 align-items-center">
                          <i class="pi pi-history"></i>
                          <span>
                              {{'common.actividadVigente' |translate}}
                          </span>
                      </div>
                  </ng-template>
                  <app-revocacion-respuesta [solicitudId]="solicitudId"></app-revocacion-respuesta>
              </p-tabPanel>
          </p-tabView>
      </div>
  </section>
  `
})
export class RevocacionSeguimientoComponent implements AfterViewInit {

	title: string = '';
	activeTabIndex: number = 0;

	solicitudId !: number;

	@ViewChild(RevocacionRespuestaComponent) respuestaComponent !: RevocacionRespuestaComponent;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

	constructor(private readonly _route: ActivatedRoute){
		this.solicitudId = Number(this._route.snapshot.params['solicitudId']);
	}

  ngAfterViewInit(): void {
    this.titleService.changeTitle('msg.actividadesAsociadasRevocacion');
    this.activeIndexChange(0);
  }

	activeIndexChange(index: number) {
    if (index === 0)
      this.respuestaComponent.loadComponent();
  }
}
